import { render, staticRenderFns } from "./EditTagsPanel.vue?vue&type=template&id=cc0eb7c8"
import script from "./EditTagsPanel.vue?vue&type=script&lang=js"
export * from "./EditTagsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports